import once from 'lodash/once';
import Tracking from '@spotahome/soyuz-tracking';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { useEcommerceManagerFactory } from '@spotahome/ecommerce-tracking';

const useHomecardListTracking = cityId => {
  const ecommerceManager = useEcommerceManagerFactory();
  const triggerHotjarPermanentBookingRecording = once(() => {
    Tracking.hotjar.triggerEvent('permanent_booking_search');
  });

  const trackProductImpressions = (cardList, indexedHomecards) => {
    try {
      const cardListWithoutSoldouts = cardList.filter(m => !m.so);
      const cardIds = cardListWithoutSoldouts.map(m => m.id.toString());
      const homecardsWithoutSoldouts = Object.fromEntries(
        Object.entries(indexedHomecards).filter(([id]) => cardIds.includes(id))
      );

      ecommerceManager.trackSearchPageImpressions(
        cardListWithoutSoldouts,
        homecardsWithoutSoldouts,
        cityId
      );

      SoyuzAnalytics.sendGA4Event('show', {
        section: 'soldout-homecard-list',
        items: cardList
          .filter(m => m.so)
          .map(m => ({
            item_id: m.id
          }))
      });
    } catch (err) {
      console.error(err);
    }
  };

  const trackHomecardClick = (position, cardData) => {
    SoyuzAnalytics.sendGA4Event('homecard_click', {
      id: cardData.id,
      position,
      cityId,
      metric_id: 'isMultiListing',
      metric_value: cardData.totalCountMultilistings > 0
    });
    ecommerceManager.trackSearchPageHomecardClick(cardData, position, cityId);
  };

  const triggerHotjarRecording = (homecards = {}) => {
    const hasHomecardWithPermanentDuration = Object.values(homecards).find(
      homecard => homecard.allowsPermanentContract
    );

    if (hasHomecardWithPermanentDuration) {
      triggerHotjarPermanentBookingRecording();
    }
  };

  return {
    trackInitialMount: (markerList, homecards) => {
      trackProductImpressions(markerList, homecards);
      triggerHotjarRecording(homecards);
    },
    trackProductImpressions,
    trackHomecardClick,
    triggerHotjarRecording
  };
};

export default useHomecardListTracking;
